import 'react-simple-hook-modal/dist/styles.css';
import raufuchat from '../../../images/raufuchat.PNG'
import React from 'react';
import {
      Modal,
      useModal,
      ModalTransition,
} from 'react-simple-hook-modal';
const Raufuchat = () => {

      const { isModalOpen, openModal, closeModal } = useModal();

      return (

            <div className="col-md-6">
                  <div data-aos="zoom-in-up" style={{height:'400px'}}>
                        <img onClick={openModal} src={raufuchat} data-tip="Click to open Project" className="img-fluid sites link px-5" alt="" srcset="" />
                  </div>

                  <Modal
                        modalClassName="rsm-bg-gray-700"
                        id="any-unique-identifier"
                        isOpen={isModalOpen}
                        transition={ModalTransition.BOTTOM_UP}
                  >
                        <button onClick={closeModal} className='btn'><i style={{ fontSize: '30px' }} class="fas fa-times-circle brand"></i></button>

                        <div className="container">
                              <img className='img-fluid' src={raufuchat} alt="" />
                              <h2 className='fs-4 mt-3 text-white'>RAUFU VIDEO CHAT</h2>
                              <div className="row mt-2">
                                    <div className="col-sm-6 d-flex justify-content-start">
                                          <a href="https://raufuchat.netlify.app/" target="_blank" rel='noreferrer'>
                                                <button style={{ backgroundColor: 'rgb(220, 90, 90)'}} className='btn site-static-button'>VISIT WEBSITE</button>
                                          </a>
                                    </div>
                                    <div className="col-sm-6 d-flex d-flex justify-content-end">
                                          <a href="https://github.com/iamraufu/raufuchat" target="_blank" rel='noreferrer'>
                                                <button className='btn hvr-sweep-to-right'>KNOW MORE</button>
                                          </a>
                                    </div>
                              </div>
                              <p className='text-white mt-2'>Developed a WEBRTC Video Chat App with real time communication capabilities for voices and video communication.</p>
                              <ul>
                                    <li>Used real time communication technology <b className='brand brand-link'>Socket.io</b> and Backend technology <b className='brand brand-link'>Node JS</b>.</li>
                              </ul>
                        </div>
                        <button onClick={closeModal} style={{ backgroundColor: 'rgb(220, 90, 90)'}} className='col-md-12 btn site-static-button'>CLOSE</button>
                  </Modal>

            </div>
      );
};

export default Raufuchat;